import { FC } from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';

interface AffiliateRegistrationProps {
  userId: string;
}

export const AffiliateRegistration: FC<AffiliateRegistrationProps> = ({ userId }) => {
  const navigate = useNavigate();

  const handlePartnerRegistration = async () => {
    try {
      // Actualizar el perfil del usuario marcándolo como partner
      const { error } = await supabase
        .from('profiles')
        .update({ is_partner: true })
        .eq('id', userId);

      if (error) throw error;

      // Mostrar mensaje de éxito
      toast.success('¡Bienvenido al programa de partners!');
      
      // Redirigir al panel de partners
      navigate('/partners');
    } catch (error) {
      console.error('Error registering partner:', error);
      toast.error('Hubo un error al registrarte como partner. Por favor intenta de nuevo.');
    }
  };

  return (
    <div className="mt-4 p-4 bg-green-50 rounded-lg">
      <p className="text-green-700 mb-4">
        ¡Felicitaciones! Has cumplido con todos los requisitos para ser socio. 
        Dale click al botón para acceder a tu panel de Partners y comenzar a ganar comisiones.
      </p>
      <Button 
        onClick={handlePartnerRegistration}
        className="w-full sm:w-auto bg-primary hover:bg-primary-dark text-white"
      >
        Acceder al Panel de Partners
      </Button>
    </div>
  );
};